/**
 * Lumina Donation Request form – submit to Klaviyo via AJAX, show confirmation on page (no redirect).
 */
(function() {
  document.addEventListener('DOMContentLoaded', function() {
    const form = document.getElementById('LuminaSignupForm');
    if (!form) return;

    const submitButton = form.querySelector('button[type="submit"]');
    const successMessage = form.querySelector('.get-in-touch__message--success');
    const errorMessage = form.querySelector('.get-in-touch__message--error');
    const errorMessageText = errorMessage ? errorMessage.querySelector('.get-in-touch__message-text') : null;
    const usePlanField = document.getElementById('LuminaSignup-use-plan');
    const usePlanCounter = document.getElementById('LuminaSignup-use-plan-counter');

    var listId = form.getAttribute('data-klaviyo-list-id');
    if (!listId || listId.trim() === '') {
      if (errorMessageText) {
        errorMessageText.textContent = 'Form is not configured: missing Klaviyo list ID.';
        errorMessage.classList.add('visible');
      }
      return;
    }

    // Character counter for "How do you plan to use..." textarea
    if (usePlanField && usePlanCounter) {
      usePlanField.addEventListener('input', function() {
        var remaining = 750 - this.value.length;
        usePlanCounter.textContent = remaining + ' characters remaining';
        usePlanCounter.classList.toggle('get-in-touch__char-count--warning', remaining < 100);
      });
    }

    form.addEventListener('submit', function(e) {
      e.preventDefault();

      successMessage.classList.remove('visible');
      errorMessage.classList.remove('visible');

      if (usePlanField && usePlanField.value.length > 750) {
        if (errorMessageText) errorMessageText.textContent = 'Please limit your response to 750 characters.';
        errorMessage.classList.add('visible');
        return;
      }

      submitButton.disabled = true;
      submitButton.textContent = 'Submitting...';
      form.classList.add('loading');

      var ajaxUrl = form.getAttribute('data-ajax-submit');
      if (!ajaxUrl) {
        showError('Configuration error.');
        return;
      }

      var params = new URLSearchParams();
      var formData = new FormData(form);
      for (var pair of formData.entries()) {
        if (pair[1] !== '') {
          params.append(pair[0], pair[1]);
        }
      }

      var street = form.querySelector('#LuminaSignup-school-street');
      var city = form.querySelector('#LuminaSignup-school-city');
      var state = form.querySelector('#LuminaSignup-school-state');
      var zip = form.querySelector('#LuminaSignup-school-zip');
      if (street && city && state && zip) {
        var parts = [street.value.trim(), city.value.trim(), state.value.trim(), zip.value.trim()].filter(Boolean);
        if (parts.length) {
          params.append('Lumina School Address', parts.join(', '));
        }
      }

      params.append('$source', '$embed');
      params.append('$method_type', 'Klaviyo Form');
      params.append('$method_id', 'embed');

      fetch(ajaxUrl, {
        method: 'POST',
        mode: 'no-cors',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: params.toString()
      })
        .then(function() {
          showSuccess();
        })
        .catch(function(err) {
          console.warn('Lumina signup fetch error (may still have succeeded):', err);
          showSuccess();
        });

      function showSuccess() {
        form.classList.remove('loading');
        submitButton.disabled = false;
        submitButton.textContent = 'Submit application';
        successMessage.classList.add('visible');
        errorMessage.classList.remove('visible');
        form.reset();
        if (usePlanCounter) {
          usePlanCounter.textContent = '750 characters remaining';
          usePlanCounter.classList.remove('get-in-touch__char-count--warning');
        }
        successMessage.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        setTimeout(function() {
          successMessage.classList.remove('visible');
        }, 8000);
      }

      function showError(msg) {
        form.classList.remove('loading');
        submitButton.disabled = false;
        submitButton.textContent = 'Submit application';
        if (errorMessageText) errorMessageText.textContent = msg;
        errorMessage.classList.add('visible');
        successMessage.classList.remove('visible');
        errorMessage.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
    });
  });
})();
